// extracted by mini-css-extract-plugin
module.exports = {"link":"contractlink_link__2Pawm"};